import { createFileRoute } from '@tanstack/react-router';

import { LandingConcept } from '#features/landing/components/LandingConcept';

export const Route = createFileRoute('/{-$locale}/_layout/preview/landing-product')({
  staticData: { rendersOwnFooter: true },
  component: LandingProductPreview,
  ssr: false,
});

function LandingProductPreview() {
  const { locale } = Route.useParams();
  return <LandingConcept variant="product" language={locale === 'ru' ? 'ru' : 'en'} />;
}
